import React from "react";
import Context from "../../Context";
import Select from "react-select";
export default class TypeChanger extends React.Component {
  static contextType = Context;
  constructor(props) {
    super(props);
    this.state = {
      pending: false,
      items: [],
      value: this.props.defaultValue,
    };
  }
  componentDidMount() {
    this.load();
  }
  componentDidUpdate(prevProps) {
    if (prevProps.defaultValue !== this.props.defaultValue) {
      this.setState({ value: this.props.defaultValue });
    }
    if (prevProps.classCode !== this.props.classCode) {
      this.load();
    }
  }
  load = async () => {
    let items = [];
    let types = this.context.user.getTypesByClasscode(this.props.classCode);
    if (Array.isArray(types)) {
      items = types.map((type) => {
        return { value: type.id, label: type.name };
      });
    }
    this.setState({ items });
  };

  onChange = (result) => {
    if (this.props.onChange) {
      this.props.onChange(result.value);
    }
  };

  render() {
    if (this.state.items.length < 2) return null;

    const select = (
      <Select
        value={this.context.api.getReferenceValue(
          this.state.value,
          this.state.items
        )}
        isLoading={this.state.pending}
        onChange={this.onChange}
        className="from-control react-select"
        classNamePrefix="react-select-inner"
        options={this.state.items}
        placeholder="Выберите тип"
        noOptionsMessage={({ inputValue }) =>
          `Ничего не найдено по запросу ${inputValue}`
        }
      />
    );

    return this.props.wrap(select);
  }
}
